import mixpanel from './mixpanel';
import {getContext, setContext} from './context';

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    mixpanel.track(eventName, {
        ...getContext(),
        ...properties,
    });
};

export const trackPageView = (pageName: string) => {
    trackEvent('Page View', {page: pageName});
};

export const identifyUser = (userId: string) => {
    if (userId) {
        mixpanel.identify(userId);
        setContext({user_id: userId});
    }
};

export const setUserProperties = (properties: Record<string, any>) => {
    mixpanel.people.set(properties);
    setContext(properties); // 예: subscription_tier 등도 저장
};
